export default __webpack_public_path__ + "d1e34c30d0d40210b50126959775ca96.svg";